import React, { useEffect, useState } from 'react';
import { sseService } from '../services/sse';
import styles from './UltimosPedidos.module.css';
import { numeroExibicaoPedido } from '../utils/pedido';

function UltimosPedidos() {
  const [pedidos, setPedidos] = useState([]);

  useEffect(() => {
    // Conectar ao SSE do estabelecimento
    const estabelecimentoId = localStorage.getItem('estabelecimento_id');
    if (estabelecimentoId) {
      sseService.connect(estabelecimentoId);
    }

    // Escutar evento de novo pedido
    const handleNovoPedido = (data) => {
      console.log("Novo pedido recebido:", data.pedido);
      // Adicionar o novo pedido à lista
      setPedidos(prevPedidos => [...prevPedidos, data.pedido]);
    };

    sseService.on("novo_pedido", handleNovoPedido);

    // Remover listener quando o componente for desmontado (não desconectar - SSE é compartilhado)
    return () => {
      sseService.off("novo_pedido", handleNovoPedido);
    };
  }, []);

  return (
    <div className={styles.pedidosContainer}>
      <h2>Últimos Pedidos</h2>
      <ul>
        {pedidos.map((pedido) => (
          <li key={pedido.id_pedido}>
            <p>Pedido #{numeroExibicaoPedido(pedido)}</p>
            <p>Forma de Pagamento: {pedido.forma_de_pagamento}</p>
            <p>Total: {pedido.total}</p>
            {/* Exiba outros detalhes do pedido conforme necessário */}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default UltimosPedidos;
